import {
  LanguageNameSpaces,
  MarketplaceSubGroup,
  TagName,
} from "@shared/types";
import React, { CSSProperties } from "react";
import { useTheme } from "styled-components";
import Tag from "common/Tags/Tag";
import {
  TAG_NAME_TO_PROPERTY_NAME,
  TagNameToColor,
} from "@shared/common/constants";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { StatusChip } from "features/newMarketplace/NewLook/NewLookGroupParts";

interface MarketplaceTagProps {
  tagName: TagName;
  group?: MarketplaceSubGroup;
  discount?: number;
  style?: CSSProperties;
}

const MarketplaceTag = ({
  tagName,
  group,
  discount,
  style,
}: MarketplaceTagProps) => {
  const { t: tCommon } = useTypedTranslation(LanguageNameSpaces.COMMON);
  const { t } = useTypedTranslation(LanguageNameSpaces.MARKETPLACE);
  const appTheme = useTheme();
  const showTag = group?.[TAG_NAME_TO_PROPERTY_NAME[tagName]] || !!discount;

  const tagText =
    tagName === TagName.SALE
      ? t("tags.discount", {
          discount: discount || group?.[TAG_NAME_TO_PROPERTY_NAME[tagName]],
        })
      : tCommon(tagName).toUpperCase();

  if (appTheme.isNewLook) {
    if (!showTag) return null;
    return (
      <StatusChip>
        {tagName === TagName.SALE ? tagText : tCommon(tagName)}
      </StatusChip>
    );
  }

  return (
    <>
      {!!showTag && (
        <Tag
          color={appTheme.colors[TagNameToColor[tagName]] as string}
          style={{ width: "max-content", ...style }}
        >
          {tagText}
        </Tag>
      )}
    </>
  );
};

export default MarketplaceTag;
